<template>
  <v-card class="rounded-lg">
    <v-card-title>
      Lembretes

      <v-spacer></v-spacer>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>

      <v-spacer></v-spacer>

      <NovoLembrete @form-submit="add_lembrete" />
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="lembretes"
      :search="search"
      :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
      sort-by="titulo"
      class="elevation-1 rounded-lg"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <RemoverLembrete :id="item.id" @form-submit="remover_lembrete" />
        <AtualizarLembrete :lembrete="item" />
      </template>

      <template v-slot:no-data> Nenhum Lembrete Cadastrado! </template>
    </v-data-table>
  </v-card>
</template>

<script>
import NovoLembrete from "./components/NovoLembrete";
import RemoverLembrete from "./components/RemoverLembrete";
import AtualizarLembrete from "./components/AtualizarLembrete";
import api from "@/services/api";
import verifica_token_storage from "@/utils/verifica_token_storage";
import { mapMutations } from "vuex";

export default {
  name: "LembretesView",

  components: {
    NovoLembrete,
    RemoverLembrete,
    AtualizarLembrete,
  },

  data: () => ({
    search: "",
    headers: [
      { text: "Código", align: "center", value: "id" },
      { text: "Titulo", align: "start", value: "titulo" },
      { text: "Tipo", align: "start", value: "tipo" },
      { text: "Descrição", align: "start", value: "descricao" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    lembretes: [],
  }),

  created() {
    this.get_init();
  },

  methods: {
    ...mapMutations(["CarregandoMutation"]),

    get_lembretes() {
      this.CarregandoMutation();

      const headers = verifica_token_storage();

      api
        .get("lembretes/", { headers })
        .then((response) => {
          this.lembretes = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.CarregandoMutation();
        })
    },

    get_init() {
      this.get_lembretes();
    },

    add_lembrete(lembrete_novo) {
      this.lembretes.push(lembrete_novo);
    },

    remover_lembrete(lembrete_id) {
      this.lembretes = this.lembretes.filter((item) => item.id != lembrete_id);
    },
  },
};
</script>
